import { instance } from 'api/api';
import { APIResponse, IDType } from 'tools/types';
import { SelectValue, TagSource } from 'app/editor/page/variables';
import { TemplateVariableAction } from 'app/editor/page/index';

export interface UploadAssetResponse {
    status: 'OK' | 'ERROR';
    file_name: string;
    portal_page_asset_id: string;
    relative_path?: string;
}

export interface LoadPageSelectData {
    portalPageId: IDType;
    source: TagSource;
    additionalOptions: string;
    search?: string;
    key: string;
    multiple?: string;
}

export interface ChangeTemplateResponse {
    status: 'OK' | 'ERROR';
}

export interface ChangeTemplateData {
    templateAction: TemplateVariableAction;
    templateId: IDType;
}

export interface TemplatesResponse extends SelectValue {
    selected: boolean;
}

export const pageAPI = {
    async uploadAsset(data: FormData, pageAssetUrl: string): Promise<UploadAssetResponse> {
        const response = await instance.post(pageAssetUrl, data);

        return response.data;
    },
    async loadSelectData(
        data: LoadPageSelectData,
        loadSelectDataUrl: string,
    ): Promise<{ results: Array<{ id: string; text: string } | string> }> {
        const response = await instance.post(loadSelectDataUrl, data);

        return response.data;
    },
    async loadAvailableTemplates(loadTemplatesUrl: string): Promise<Array<TemplatesResponse>> {
        const response = await instance.get(loadTemplatesUrl);

        return response.data;
    },
    async changeTemplate(data: ChangeTemplateData, changeTemplateUrl: string): Promise<ChangeTemplateResponse> {
        const response = await instance.post(changeTemplateUrl, data);

        return response.data;
    },
    async deleteAsset(assetId: string, pageAssetUrl: string): Promise<APIResponse<any>> {
        const response = await instance.delete(pageAssetUrl + '/' + assetId + '/form');

        return response.data;
    },
};
